import React from "react";
import { Heading, Text, Button, TextField } from '@aws-amplify/ui-react';

function SaveViewModal({ 
    newViewName,
    setNewViewName,
    onSubmit,
    onCancel,
    errorTooLong,
    modalStyles 
}) {

    if (errorTooLong) {
        return (
            <div style={modalStyles.overlay}>
                <div style={modalStyles.modal}>
                    <Heading level={4}>Error - Too many columns</Heading>
                    <Text>
                        You are trying to save a view with too many columns.
                        Please review your view and try again.
                    </Text>
                    <br />
                    <Button onClick={onCancel}>TRY AGAIN</Button>
                </div>
            </div>
        );
    }

    return (
        <div style={modalStyles.overlay}>
            <div style={modalStyles.modal}>
                <Heading level={4}>Save Table View</Heading>
                <Text>Would you like to save a new view?</Text>

                <TextField
                    placeholder="Name of new view"
                    value={newViewName}
                    onChange={(e) => setNewViewName(e.target.value)}
                />

                <br /><br />

                <Button onClick={onSubmit}>SUBMIT</Button>
                <Button style={{ marginLeft: "10px" }} onClick={onCancel}>
                    CANCEL
                </Button>
            </div>
        </div>
    );
}

export default React.memo(SaveViewModal);
